import * as React from 'react';

import { cn } from '../lib/cn';

export interface FormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  helperText?: React.ReactNode;
  error?: React.ReactNode;
  hideLabel?: boolean;
}

export const FormField = React.forwardRef<HTMLDivElement, FormFieldProps>(
  (
    {
      className,
      label,
      htmlFor,
      required,
      optional,
      helperText,
      error,
      hideLabel,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={cn('flex flex-col gap-1.5', className)} {...props}>
        {label ? (
          <label
            htmlFor={htmlFor}
            className={cn(
              'text-xs font-medium text-[var(--color-fg-secondary)]',
              hideLabel && 'sr-only',
            )}
          >
            {label}
            {required ? <span className="ml-0.5 text-[var(--color-danger)]">*</span> : null}
            {optional ? (
              <span className="ml-1 font-normal text-[var(--color-fg-muted)]">(optional)</span>
            ) : null}
          </label>
        ) : null}
        {children}
        {error ? (
          <p className="text-xs text-[var(--color-danger)]" role="alert">
            {error}
          </p>
        ) : helperText ? (
          <p className="text-xs text-[var(--color-fg-muted)]">{helperText}</p>
        ) : null}
      </div>
    );
  },
);
FormField.displayName = 'FormField';
